import template from './identificationModal.html';
import controller from './identificationModalCtrl';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    modalType: '<',
    familyId: '<',
    identificationSet: '<',
    loanAppId: '<',
    documentTypeList: '<',
    clientsList: '<',
  },
};
